import './440Artists.css';
import SiteLayout from '../../components/common/SiteLayout';
import Hero from '../../components/440Artists/Hero/Hero';
import ArtistRoster from '../../components/440Artists/ArtistRoster/ArtistRoster';
import HowItWorks from '../../components/440Artists/HowItWorks/HowItWorks';
import OurNetwork from '../../components/440Artists/OurNetwork/OurNetwork';
import WhatYouGet from '../../components/440Artists/WhatYouGet/WhatYouGet';
import ArtistStories from '../../components/440Artists/ArtistStories/ArtistStories';
import useScrollTracking from '../../components/common/UserScrollTracking';
export default function Artists440() {
    const sections = [
        { id: 'hero', eventName: 'Hero' },
        { id: 'what-you-get', eventName: 'Base Plan' },
        { id: 'roster', eventName: 'Roster' },
        { id: '440advantage', eventName: 'Ecosystem' },
        { id: 'artist-stories', eventName: 'Testimonials' },
        { id: 'how-it-works', eventName: 'How it Works' }
    ];

    useScrollTracking(sections);

    return (
        <SiteLayout>
            <Hero />
            <OurNetwork />
            <ArtistRoster />
            <WhatYouGet />
            <ArtistStories />
            <HowItWorks />

            {/* <FadeInSection>
                    <CaseStudies />
                </FadeInSection> */}

            {/* <FadeInSection>
                    <ComparisonTable
                        title="Why Choose 440Artists?"
                        headers={['440Artists', 'Competitor A', 'Competitor B']}
                        rows={comparisonRows}
                        className="main-comparison-table"
                    />
                </FadeInSection>

                <FadeInSection>
                    <div className='services-section'>
                        <h2 className='services-title'>Meet Our Team</h2>
                        <div className='services-grid'>
                            {services.map((service, index) => (
                                <ServiceCard
                                    key={index}
                                    name={service.name}
                                    role={service.role}
                                    description={service.description}
                                    services={service.services}
                                />
                            ))}
                        </div>
                    </div>
                </FadeInSection> */}

        </SiteLayout>
    );
}
